printLocation